// extracted by mini-css-extract-plugin
module.exports = {"result":"_3ax8y","highlighted":"_19_X0","separator":"_2kZqV"};